/**
 * Get query options set from the block configuration.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Object} api
 * @returns string|false
 */
export function getQueryOptions(api) {
    const { queryOptions } = api;

    if (queryOptions) {
        return new URLSearchParams(queryOptions).toString();
    }

    return false;
}
